var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06368 0.191685L0.145104 6.12668C-0.0486974 6.32113 -0.0483716 6.63595 0.146107 6.83008C0.34056 7.02406 0.655559 7.02356 0.849511 6.82908L6.41582 1.24736L11.9821 6.82928C12.1761 7.02373 12.4909 7.02423 12.6854 6.83028C12.7829 6.73297 12.8316 6.60548 12.8316 6.47799C12.8316 6.35083 12.7832 6.22384 12.6864 6.1267L6.76794 0.191685C6.67476 0.0980292 6.54795 0.0454746 6.41582 0.0454746C6.2837 0.0454746 6.15704 0.0981799 6.06368 0.191685Z",
    fill: "#272D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShevronUp);
export default __webpack_public_path__ + "static/media/shevron-up.d57601a62b9b30197a7892323305fc1e.svg";
export { ForwardRef as ReactComponent };